export default function getProjects() {
    return [
      {
   
        id: 1,
        image:'Travelious.png',
        projectTitle: "Travelious",
        projectInfo:
         "Build a user specific travel website in 7 days with a team of 5 members. The project offer the following functionality - login/signup, search functionality, tour page, payment page, profile and tour booking history.",
        techUsed: ["React", "Redux","ChakraUI", "Javascript", "Html"],
        projectLinkHosted: "https://travelious-project.netlify.app/",
        projectLinkGithub: "https://github.com/heyvipul/Travelious",
      },
      {
   
        id: 2,
        image:'portfolio.jpg',
        projectTitle: "Updated Portfolio",
        projectInfo: 
        "Hi Everyone, I am Vipul Girhe a Full Stack Developer who loves solving problems and building projects. I am equipped with a variety of technologies and tools to help me build the best possible product.",
        techUsed: ["Vite", "MaterialUi", "Javascript", "React-icons"],
        projectLinkHosted: "https://heyvipul.vercel.app/",
        projectLinkGithub: "https://github.com/heyvipul/newPortfolio",
      },
      {
   
        id: 3,
        image:'chatapplication.jpg',
        projectTitle: "RealTime Chat Application",
        projectInfo:
         "A Real-time Chat App developed with React frontend and NodeJS with Socket.io backend. Users can send and receive messages instantly, and receive notifications for new user activity..",
        techUsed: ["Vite", "Socket.io","Node", "Express", "React-Router"],
        projectLinkHosted: "https://heyvipul-chat-appilcation.vercel.app/",
        projectLinkGithub: "https://github.com/heyvipul/Realtime-chat-appilcation",
      },
      {
   
        id: 4,
        image:'CrytpoExplorer.jpg',
        projectTitle: "Crypto Explorer",
        projectInfo:
         "Discover the future of finance with simplicity, offering intuitive cryptocurrency exploration for all levels. Join us for seamless trading and portfolio management.",
        techUsed: ["React", "Javascript","MateriaUi", "JSON", "Vercel"],
        projectLinkHosted: "https://cryptocurrency-tracker-heyvipul.vercel.app/",
        projectLinkGithub: "https://github.com/heyvipul/cryptocurrency-tracker-react",
      },
      {
   
        id: 5,
        image:'fullstackProject.jpg',
        projectTitle: "Full Stack Project",
        projectInfo:
         "A MERN application for basic tasks management.",
        techUsed: ["React", "Redux","Node", "Express", "MongoDb"],
        projectLinkHosted: "https://arba-fullstack-assignment.vercel.app/",
        projectLinkGithub: "https://github.com/heyvipul/arba-fullstack-assignment",
      },
      {
       
        id: 6,
        image:'MineWine.png',
        projectTitle: "MineWine Clone",
        projectInfo:
         "In this project we have tried to make an Online Wine Ecommerce Website And and added functionally like Signup, Login, Search, Cart page, Payment Page. We used HTML, CSS, JavaScript ,Bootstrap, ES6 Tech Stacks to build this application.",

        techUsed: ["JavaScript", "HTML","CSS", "ES6"],
        projectLinkHosted: "https://64dc647497ed712d3fab4cb5--lambent-quokka-6e7d37.netlify.app/index.html",
        projectLinkGithub: "https://github.com/heyvipul/WineProject_Collab",
      },
      {
        id: 7,
        projectTitle: "BlueFly Clone",
        image:"bluefly.png",
        projectInfo:
          "This is a Collaborative Project. We clone the Bluefly Shopping Website and added functionally like Signup, Login, Search, Cart page, Payment Gateway. We used HTML, CSS, JavaScript Tech Stacks.",
        techUsed: ["JavaScript", "HTML", "CSS","LocalStorage","Netlify"],
        projectLinkHosted: "https://647cc4c365687c4e3c6b2b20--chimerical-madeleine-52c26c.netlify.app/",
        projectLinkGithub: "https://github.com/heyvipul/blueFly"
       
      }
    ];
  }